(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pelmori-cro-header"]) return;
  try {
    
function initPelmoriShipping(){
document.querySelectorAll('[data-shipping-bar]').forEach(bar=>{
if(bar.dataset.ready)return;bar.dataset.ready='true';
const slides=Array.from(bar.querySelectorAll('[data-shipping-slide]'));
const button=bar.querySelector('[data-shipping-pause]');
let index=0,paused=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function sync(){button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?button.dataset.playLabel:button.dataset.pauseLabel);button.textContent=paused?'▶':'Ⅱ';}
button.addEventListener('click',()=>{paused=!paused;sync();});sync();
const timer=setInterval(()=>{if(!bar.isConnected){clearInterval(timer);return;}if(paused||document.hidden||bar.matches(':hover')||bar.contains(document.activeElement))return;slides[index].hidden=true;index=(index+1)%slides.length;slides[index].hidden=false;},5000);
});
}
initPelmoriShipping();
document.addEventListener('shopify:section:load',initPelmoriShipping);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pelmori-landing-purchase-ui"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      const root = document.querySelector('.pl-product');
      const sticky = document.querySelector('[data-pelmori-sticky]');
      if (!root || !sticky || sticky.dataset.ready) return;
      sticky.dataset.ready = 'true';
      const dismissNewsletter = () => {
        document.querySelectorAll('[role="dialog"]').forEach(dialog => {
          const title = [...dialog.querySelectorAll('h2')].find(heading => heading.textContent.trim().toLowerCase() === 'subscribe to our newsletter');
          if (!title) return;
          const dismiss = [...dialog.querySelectorAll('button')].find(button => button.textContent.trim().toLowerCase() === 'no, thank you');
          if (dismiss) dismiss.click();
        });
      };
      const popupObserver = new MutationObserver(dismissNewsletter);
      popupObserver.observe(document.body, {childList: true, subtree: true});
      dismissNewsletter();
      const purchaseButton = root.querySelector('.product-form__submit');
      if (!purchaseButton) return;
      const observer = new IntersectionObserver(entries => {
        sticky.hidden = entries[0].isIntersecting;
      }, {threshold: 0.2});
      observer.observe(purchaseButton);
    };
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-pelmori-select]');
      if (!trigger) return;
      const target = document.querySelector('.pl-product variant-selects') || document.querySelector('.pl-product product-form');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center'});
      const input = target.querySelector('input:checked') || target.querySelector('select,button,input:not([type=hidden])');
      if (input) input.focus({preventScroll: true});
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
